import React, { useCallback } from 'react'
import { useMsal } from '@azure/msal-react'
import Task from 'data.task'
import { isMsAuthEnabled, noopTask, noopTaskCallback } from './utils'

const useTokensGetterTask = () => {
  const { instance } = useMsal()
  const getTokens = useCallback(
    account =>
      account
        ? new Task((err, resolve) => {
            instance
              .acquireTokenSilent({
                scopes: ['User.Read'],
                account: account,
              })
              .then(resolve)
              .catch(err)
          })
        : noopTask,
    [instance]
  )
  return [isMsAuthEnabled ? getTokens : noopTaskCallback]
}

export default useTokensGetterTask
